import { useEffect, type ReactNode } from 'react';

import { useUiStore } from '@/store/ui';

/**
 * Haelt die `dark`-Klasse auf `<html>` in Sync mit der Einstellung.
 *
 * Der ERSTE Wert wird bereits in `index.html` gesetzt, bevor React laedt -
 * sonst blitzt beim Start der helle Modus auf.
 */
export function ThemeProvider({ children }: { children: ReactNode }) {
  const theme = useUiStore((s) => s.theme);

  useEffect(() => {
    const media = window.matchMedia('(prefers-color-scheme: dark)');

    const apply = () => {
      const dark = theme === 'dark' || (theme === 'system' && media.matches);
      document.documentElement.classList.toggle('dark', dark);
    };

    apply();
    if (theme !== 'system') return;

    media.addEventListener('change', apply);
    return () => media.removeEventListener('change', apply);
  }, [theme]);

  return <>{children}</>;
}
